
export default function Footer(){
  return (
    <div className="signature">
      Tony Kieling<span>&nbsp;™️ &nbsp;–&nbsp;  2021</span>
    </div>
  )
}